module.exports = __webpack_public_path__ + "img/Rogue.fcbba048.png";